import React, { Component } from "react";
import Uploader from "../uploader";

export default class MobileCeilings extends Component {
  render() {
    return (
      <div className="relative">
        <button
          name="scroll-right"
          className="m-0 button-shadow-right scroll"
        ></button>

        <ul>
          {this.props.ceilings.map((ceiling) => (
            <li
              onClick={() => this.props.selectHandler("ceiling", ceiling)}
              style={{
                background: ceiling.color_code ? ceiling.color_code : "",
              }}
              key={"ceilingImage" + ceiling.id}
              className={
                this.props.selectedCeiling &&
                this.props.selectedCeiling.id === ceiling.id
                  ? "active"
                  : ""
              }
            >
              {" "}
              {ceiling.image && <img src={ceiling.image} alt="cover" />}{" "}
            </li>
          ))}
        </ul>
        <button
          name="scroll-left"
          className="m-0 button-shadow-left scroll"
        ></button>
        <Uploader
          selected={
            this.props.selectedCeiling && this.props.selectedCeiling.custom
              ? this.props.selectedCeiling
              : null
          }
		  selectHandler={this.props.customSelectHandler}
		  removeHandler={this.props.removeHandler}
		  decorationType={"ceiling"}
		  texts={this.props.texts}
        />
      </div>
    );
  }
}
